module.exports = __webpack_public_path__ + "media/svg-new/unlock 6-203338f3.svg";